import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntil, first } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

import { AuthenticationService } from '../../../../app/auth/service';
import { CoreConfigService } from '../../../../@core/services/config.service';
import { User } from '../../../auth/models';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';

	@Component({
		selector: 'app-login',
		templateUrl: './login.component.html',
		styleUrls: ['./login.component.scss'],
		encapsulation: ViewEncapsulation.None
	})
export class LoginComponent implements OnInit {
	hideButton: boolean = false;
	private targetDate = new Date('2025-010-18T23:59:00');
	//  Public
	public coreConfig: any;
	public loginForm: FormGroup;
	public loading = false;
	public submitted = false;
	public returnUrl: string;
	public error = '';
	public passwordTextType: boolean;
	public checked = false;
	public captcha: any;

	// Private
	private _unsubscribeAll: Subject<any>;
	public currentUser: Observable<User>;
	private currentUserSubject: BehaviorSubject<User>;
	category: any;
	/**
	 * Constructor
	 *
	 * @param {CoreConfigService} _coreConfigService
	 */
	constructor(
		private _coreConfigService: CoreConfigService,
		private _formBuilder: FormBuilder,
		private _route: ActivatedRoute,
		private _router: Router,
		private _authenticationService: AuthenticationService,
		private CookieService:CookieService
	) {
		// redirect to home if already logged in

		if (this._authenticationService.currentUserValue) {
			
			//this._router.navigate(['/euttc-proposal']);
			this._router.navigate(['/my-application']);
		}

		this._unsubscribeAll = new Subject();

		// Configure the layout
		this._coreConfigService.config = {
		layout: {
			navbar: {
			hidden: true
			},
			menu: {
			hidden: true
			},
			footer: {
			hidden: true
			},
			customizer: false,
			enableLocalStorage: false
		}
		};

		this.category = [ {categoryName:'Solar', categoryID:1}, 
						{categoryName:'Wind', categoryID:2}, 
						{categoryName:'Small Hydro', categoryID:3},
						{categoryName:'Waste to Energy', categoryID:4},
						{categoryName:'Bio Energy', categoryID:5}];
	}

	// convenience getter for easy access to form fields
	get f() {
		return this.loginForm.controls;
	}

	/**
	 * Toggle password
	 */
	togglePasswordTextType() {
		this.passwordTextType = !this.passwordTextType;
	}

	onSubmit() {
		this.submitted = true;
		
		if(this.loginForm.get('captcha').value==this.captcha)
		{

		// stop here if form is invalid
		if (this.loginForm.invalid) {
			return;
		}
		this.loading = true;
		let key: any;
		//key = "AHASolar12345678";
		key = environment.cryptoJSKey;
		let iv  = environment.cryptoJSIV;
		
		var utf8String = CryptoJS.enc.Utf8.parse(this.f.email.value);
		const encryptedEmail = CryptoJS.AES.encrypt(utf8String,key,
		{
			keySize: 128 / 8,
			ivs: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		}).toString();

		const encryptedPassword = CryptoJS.HmacSHA256(this.f.password.value, key).toString();
		// Login
		this.loading = true;
		this._authenticationService
		.login(this.f.email.value,encryptedPassword)
		.pipe(first())
		.subscribe(
			result => {
				if(result && result.goToResetPassword != undefined && result.goToResetPassword == 1){ 
					const customerId = result.customerId;
					const URL = '/reset-password/'+customerId+'/'+encryptedEmail;
					this._router.navigate([URL]);
				}else if(result && result.goToResetPassword != undefined && result.goToResetPassword == 0){


					if(this.loginForm.get('rememberMe').value==true)
						{
							const expiresDate = new Date();
                            expiresDate.setFullYear(expiresDate.getFullYear() + 1);
							this.CookieService.set('r_email', this.f.email.value,expiresDate);
							this.CookieService.set('r_password', this.f.password.value,expiresDate);
							this.CookieService.set('remember_me', 'true', expiresDate);
							
						}
					if(result.role=='User')
					{
                    this._router.navigate(['/euttc-proposal']);
					}else{
					this._router.navigate([this.returnUrl]);
					}
				}else{
					this.captcha = this.loadcaptcha();
					this.error = "Invalid Username and Password.";
					this.loading = false;  
				}
			},
			error => {
				this.captcha = this.loadcaptcha();
				this.error = error;
				this.loading = false;
			}
		);

	}else{
		alert('Please enter a valid captcha');
		this.submitted = false;
	}
	}

	// Lifecycle Hooks
	// -----------------------------------------------------------------------------------------------------

	
	  
	/**
	 * On init
	 */
	ngOnInit(): void {
		//this.hideButton = new Date() >= this.targetDate;
		this.checkTime();
		//setInterval(() => this.checkTime(), 1000); // Check every second
		this.captcha = this.loadcaptcha();
		//const rememberMe = this.CookieService.get('remember_me') === 'true';
		const rememberMe = 'false';
		this.loginForm = this._formBuilder.group({
		email: [this.CookieService.get('r_email'), [Validators.required, Validators.email]],
		password: [this.CookieService.get('r_password'), Validators.required],
		captcha: ['', Validators.required],
		rememberMe: [false]
		//realcaptcha: ['', Validators.required]
		}
		// ,{
		// 	validator: this.ConfirmedValidator(this.captcha, 'captcha'),
		//   }
		);
		// get return url from route parameters or default to '/'
		this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/my-application';
		this.loginForm.patchValue({
			realcaptcha:this.captcha
		 });
		// Subscribe to config changes
		this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
		this.coreConfig = config;
		});
	}

	checkTime() {
		const now = new Date();
		this.hideButton = now >= this.targetDate;
	  }

	ConfirmedValidator(controlName: string, matchingControlName: string) {
		return (formGroup: FormGroup) => {
		  const control = formGroup.controls[controlName];
		  const matchingControl = formGroup.controls[matchingControlName];
		  if (
			matchingControl.errors &&
			!matchingControl.errors.confirmedValidator
		  ) {
			return;
		  }
		  if (control.value !== matchingControl.value) {
			matchingControl.setErrors({ confirmedValidator: true });
		  } else {
			matchingControl.setErrors(null);
		  }
		};
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	loadcaptcha() {

		var alpha = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V'
                 ,'W','X','Y','Z','1','2','3','4','5','6','7','8','9','0','a','b','c','d','e','f','g','h','i',
                 'j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z', '!','@','#','$','%','^','&','*','+'];
                 var a = alpha[Math.floor(Math.random()*71)];
                 var b = alpha[Math.floor(Math.random()*71)];
                 var c = alpha[Math.floor(Math.random()*71)];
                 var d = alpha[Math.floor(Math.random()*71)];
                 var e = alpha[Math.floor(Math.random()*71)];
                 var f = alpha[Math.floor(Math.random()*71)];

                 this.captcha = a+b+c+d+e+f;
				
//console.warn(this.captcha);
		return this.captcha;
	}

	reloadPage(){
		window.location.reload()
	  }
}


	// const encryptedPassword = this.encryptUsingAES256(this.f.password.value);
		// const decryptedPassword = this.decryptUsingAES256();
		//const salt = bcrypt.genSaltSync(10);
		//const encryptedPassword = bcrypt.hashSync(this.f.password.value, salt);
		//const salt = bcrypt.genSaltSync(10);
		//const pass = bcrypt.hashSync(this.f.password.value);
		// console.log(key.toString());
		// console.log(encryptedPassword.toString());